import { cn } from '@/lib/utils';

// Copied from HMHWatch's WindowTabs (the editorial segmented toggle) — same window
// contract the mna brief API serves: ?window=24h|7d|30d.

export type BriefWindow = '24h' | '7d' | '30d';

const labels: Array<{ id: BriefWindow; label: string }> = [
  { id: '24h', label: 'Last day' },
  { id: '7d', label: 'Last week' },
  { id: '30d', label: 'Last month' },
];

type Props = {
  value: BriefWindow;
  onChange: (id: BriefWindow) => void;
};

/**
 * Editorial segmented toggle. Thin bottom rule with an underline indicator
 * under the active item — no filled pills, no heavy borders.
 */
export function WindowTabs({ value, onChange }: Props) {
  return (
    <div role="tablist" aria-label="Time window" className="inline-flex gap-0 border-b border-border">
      {labels.map(({ id, label }) => {
        const active = value === id;
        return (
          <button
            key={id}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(id)}
            className={cn(
              'font-(family-name:--font-ui) text-[0.72rem] font-semibold uppercase tracking-[0.2em]',
              'px-4 py-2.5 min-h-11 -mb-px border-b-2 transition-colors whitespace-nowrap',
              active ? 'text-text border-accent' : 'text-muted border-transparent hover:text-text'
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
